import { Rating } from '../rating/rating';
import { Tag } from '../tag/tag';
import { Button } from '../button/button';
import { ReactComponent as ArrowRight } from '../../../assets/arrow-right.svg';
import './organization.css';
import { convertToTitleCase } from '../../../utils/text';
import { currencyFormatter } from '../../../utils/numbers';
import { useOrganizations, useOrganizationsDispatch } from '../../../contexts/organization-context';
import * as cn from 'classnames';
import { useNavigation } from '../../../contexts/navigation-context';
import saltExchangeLogo from '../../../assets/loading.png';

export const Organization = ({ organization, activities }) => {
  const { organizationIds } = useOrganizations();
  const dispatch = useOrganizationsDispatch();
  const { getCurrentPage, to } = useNavigation();

  const handleDetailsClick = (e) => {
    // onOrganizationSelect(organization);
    dispatch({ type: 'organization-selected', organizationId: organization.EIN });
    to({ pageId: 'organization-detail', params: { organizationId: organization.EIN } });
    e.stopPropagation();
  };

  const handleOrganizationClick = () => {
    // onOrganizationSelect(organization);
    dispatch({ type: 'organization-toggled', organizationId: organization.EIN });
  };

  const activity = activities.find((a) => a.ID === organization.ACTIVITY_ID);
  return (
    <div className={cn(['organization-container', organizationIds.includes(organization.EIN) ? 'selected' : ''])} onClick={() => handleOrganizationClick()}>
      <div className="name-container text-xlarge text-white">{convertToTitleCase(organization.NAME)}</div>
      <div className="column-container">
        <div className="column grow">
          <div className="title">Activities</div>
          <div className="tags-container">
            {!activity && <div className="text-normal text-gray-2 text-regular"> No associated activities</div>}
            {activity && <Tag tag={activity}></Tag>}
            {organization.ACTIVITY_COUNT > 1 && <Tag tag={{ NAME: '+ ' + String(organization.ACTIVITY_COUNT - 1) }}></Tag>}
          </div>
        </div>
        <div className="column centered shrink">
          <div className="title">Screened</div>
          <div>
            <img className={cn('is-screened-icon', !organization.IS_SCREENED && 'not-screened')} src={saltExchangeLogo} alt="Screened" />
          </div>
        </div>
      </div>
      <div className="column-container">
        <div className="column">
          <div className="title">Total Revenue {organization.TAX_YEAR && '(' + organization.TAX_YEAR + ')'}</div>
          <div className="value">
            {!organization.REVENUE ? <div className="text-regular text-gray-2 text-normal">Unknown</div> : currencyFormatter.format(organization.REVENUE)}
          </div>
        </div>
        <div className="column">
          <div className="title">Charity Navigator</div>
          <div className="rating-container">
            <Rating rating={organization.CHARITY_NAVIGATOR_RATING} />
          </div>
        </div>
      </div>
      <div className="buttons-container">
        <Button icon={<ArrowRight />} size="large" onClick={(e) => handleDetailsClick(e)} textAlign="center">
          View more
        </Button>
      </div>
    </div>
  );
};
